import { data } from "jquery";

const info = {
  ZH: {
    //中文翻译
    colon: "：",
    select: "请选择...",
    create: "创建",
    find: "查找",
    view: "查看",
    warn: "警告",
    continue: "继续",
    submit: "提交",
    pleaseSelect: "请先选择数据",
    inputModify: "修改",
    noDataUpdate: "无数据更新",
    noFileDownload: "无文件下载",
    export: "导出",
    templateDownload: "模板下载",
    textDescription: "文字描述",
    file: "附件",
    contactInformation: "联系方式",
    // reset: "重置",
    // add: "添加",
    status0: "未分析",
    status1: "成功",
    status2: "失败",
    status3: "处理中",
    status4: "完成",
    operate: "操作",
    newAdd: "新增",
    modify: "编辑",
    noData: "无数据",
    setSuccessfully: "设置成功",
    unset: "取消设置",
    // delete: "删除",
    pleaseInput: "请输入",
    positiveInteger: "正整数",
    yes: "是",
    no: "否",
    tips: "提示",
    sendSuccess: "发送成功",
    success: "成功",
    rowSelect: "请选择数据",
    received: "已接收的",
    mdsUpdateResults: "更新结果",
    compare:"对比",
    startCompare:"开始对比",
    joined:"已加入",
    // confirm: "确 定",
    // cancel: "取 消",
    metalPPM: "金属限值(<=):",
    nonMetallicPPM: "非金属限值(<=):",
    sort: "分类:",
    classification: "分类",
    CustomSettings: "自定义设置",
    subInformationFill: "物品信息填报",
    workSpaceInformationFill: "工作空间",
    validate: "信息验证",
    checkDossier: "查看档案",
    createDossier: "创建档案",
    exportDossier: "档案导出",
    submitECHA: "提交ECHA",
    revalidate: "重新验证",
    editDossier: "编辑档案标题",
    exportExcel: "导出Excel",
    save: "保存",
    confirmCommit: "确认提交",
    confirmSend: "确认发送",
    confirmReply: "回复确认",
    confirmed: "已确认",
    confirm: "确认",
    logout: "退出",
    systemFolder: "系统文件",
    ModelFile: "车型文件",
    logoTit: "SCIP数据库辅助申报工具",
    reviewTheRules: "审核规则",
    reviewInformation: "审核信息",
    regulatoryInformation: "法规信息",
    taggingRulesList: "回收利用阶段自动标注规则",
    taggingRulesInfo: "材料范围判定管理",
    camds_system: "CAMDS",
    imds_system: "IMDS",
    Localsystem: "本地创建",
    searchCriteria: "查询条件",
    LocalData: "本地数据管理",
    departmentInfo: "部门信息",
    BasicDataSynchronization: "基础数据同步",
    MDSDataSynchronization: "MDS数据同步",
    DataSynchronization: "数据同步",
    auditDistribute: "审核分发",
    userManage: "用户信息",
    pageViews: "浏览量",
    statisticalChart:'统计图表',
    personalManage: {
      organization: "组织信息",
      car: "车型信息",
    },
    // RoleManage: '角色信息',
    LogManage: "日志信息",
    ConfigurationManage: {
      data: "数据下载账号配置",
      add: "新增账号密码配置",
      help: "帮助提示内容配置",
      banner: "公告信息配置",
      BOM: "BOM信息字段配置",
      Datastate: "下载CAMDS本地创建表单自动批准",
    },
    // ModelInformation: '车型信息',
    ModelBOMList: "车型BOM信息",
    startTime: "开始时间:",
    endTime: "结束时间:",
    operationTime: "操作时间:",
    enterpriseInformation: "企业信息",
    primarySubstance: "基本物质",
    standardMaterial: "标准材料",
    materialsClassification: "材料分类",
    ApplicationOfOption: "应用选项",
    PolymerLabel: "聚合物标识",
    quotedStandard: "引用标准",
    serialNumber: "序号",
    operator: "操作人",
    chickoperationTime: "选择时间:",
    Synchronization: "同步内容",
    parameter: "参数",
    result: "执行结果",
    explain: "说明",
    SynchronizationSuccse: " 同步成功！",
    down: "展开",
    up: "收起",
    Formtype: "表单类型:",
    FormTheSource: "表单来源:",
    FormID: "表单ID:",
    productName: "商品名称:",
    SupplierID: "供货编号:",
    cstandardSymbol: "标准材料号:",
    CreateAnEnterprise: "创建企业:",
    dataState: "数据状态:",
    auditStatus: "审核状态:",
    QueryTimeType: "查询时间类型:",
    IDversions: "ID/版本:",
    MDSState: "MDS状态:",
    acceptingState: "接收状态:",
    downloadStatus: "下载状态:",
    downloadResults: "下载结果:",
    CAMDSloginName: "CAMDS账号:",
    IMDSloginName: "IMDS账号:",
    CAMDSpassword: "CAMDS密码:",
    FirstResponsiblePerson: "一级责任人:",
    SecondaryResponsiblePerson: "二级责任人:",
    ThirdPartyResponsiblePerson: "三级责任人:",
    enterpriseID: "企业ID:",
    brandName: "品牌名称:",
    modelName: "车型名称:",
    BOMType: "BOM类型:",
    BannerType: "公告类型:",
    vehicle: "车型分类:",
    commonName: "通用名称:",
    ModelType: "车型型号:",
    type: "类型:",
    style: "款式:",
    Themass: "整车质量(Kg):",
    quality: "质量(g):",
    Quality: "质量:",
    manufacturingEnterprise: "生产企业:",
    dateCreated: "创建日期:",
    bannerDate: "公告时间:",
    optionDate: "选择日期:",
    Announcement: "公告批次:",
    name: "名称:",
    CheckTheType: "校验类型:",
    availableOrNot: "是否启用:",
    lawsName: "法规名称:",
    lawsType: "法规类型:",
    updateTime: "更新时间:",
    matterName: "物质名称:",
    materialName_en: "材料名称(外文):",
    enName: "英文名称:",
    CASNum: "CAS号:",
    materialClassification: "物质分类:",
    ratio: "比例:",
    materialCategories: "材料类别:",
    mixCategories: "混合分类:",
    MarkPhase: "标注阶段:",
    MTRTechnology: "mTr已验证技术:",
    materialsRange: "材料范围:",
    MaterialIdentification: "材料标识:",
    materialName: "材料名称:",
    fileType: "文件类型:",
    fileName: "文件名称:",
    remarks: "备注:",
    NameOfEnterprise_department: "企业/部门名称:",
    CAMDS_ID: "CAMDS系统ID:",
    industryTitle: "部门名称:",
    SuperiorOrganization: "上级组织机构:",
    user_Name: "姓名:",
    Login_Name: "登录名:",
    role: "角色:",
    phone: "联系电话:",
    email: "电子邮箱:",
    RoleManage: "角色信息:",
    ModelInformation: "车型信息:",
    oldPassword: "原密码:",
    newPassword: "新密码:",
    reconfirm: "再次确认:",
    CharacterName: "角色名称:",
    DataPermission: "数据权限:",
    MenuPermissions: "菜单权限:",
    operationType: "操作类型:",
    FirmName: "企业名称:",
    FirmID: "企业ID:",
    TheNewTips: "新提示:",
    CurrentTips: "当前提示:",
    SynchronousTime: "同步时间:",
    SynchronousStateTime: "同步状态时间:",
    OpenSynchronization: "开启同步:",
    password: "密码:",
    UserID: "用户ID:",
    AccessAddress: "访问地址:",
    KEY: "KEY值:",
    UserName: "用户名:",
   
    FilterType: "筛选类型:",
    mpType: "mP类别:",
    AnnotatedLockedState: "标注锁定状态:",
    NodeNumberCalculation: "节点数量计算:",
    partName: "零部件名称:",
    partName_en: "零部件名称（外文）:",
    partType: "零部件类别:",
    partID: "零部件号:",
    SingleMassValueMeasuredByZeroPart: "零部件测量所得单个质量值:",
    CalculatedSingleMassValue: "计算所得单个质量值:",
    ThePolymersHaveBeenLabeled: "聚合物已被标注:",
    ThePolymersHaveBeenLabeled_item1: "是（已按照有关规定标注）",
    ThePolymersHaveBeenLabeled_item2: "否（没有按照有关规定标注）",
    ThePolymersHaveBeenLabeled_item3: "不适用（按照有关规定无须标注）",
    deviation: "偏差:",
    surveyDate: "检验日期:",
    releaseDate: "发布日期:",
    Num: "数量:",
    MaterialPartNumber: "材料件号:",
    productname: "商品名:",
    materialsClass: "材料分类:",
    MaterialCode_Mark: "材料代号/标识:",
    MaterialCode_markingReferenceStandard: "材料代号/标识引用标准:",
    markingReferenceStandard: "标识引用标准:",
    StandardNo: "标准号:",
    MaterialReportNo: "检测报告编号:",
    RecirculatingMaterial: "再循环材料:",
    Whether: "该材料是否含有再循环材料",
    T24021: "见GB/T24021",
    industrial: "从工业废料中回收的:",
    waste: "从废旧材料中回收的:",
    form: "从",
    to: "到",
    finishedName: "半成品件名称:",
    finishedName_en: "半成品件名称(英文):",
    finishedNum: "半成品件号:",
    average: "平均值",
    fixed: "固定的",
    surplus: "剩余的",
    NameOfBasicSubstance_zh: "基本物质中文名称:",
    NameOfBasicSubstance_en: "基本物质英文名称:",
    CAScode: "CAS编号:",
    ECcode: "EC编号:",
    GADSLclassify: "GADSL分类:",
    another: "别名:",
    secrecy: "保密:",
    DesignQuality: "设计质量(g):",
    materials: "材料:",
    department: "部门:",
    NameChinese: "名称是否为中文",
    ChineseName: "中文名称:",
    CommonNameofParts: "零部件通用名称:",
    HarmfulLabelingInformation: "有害标注信息:",
    RecyclingStage: "回收利用阶段:",
    Typeofpretreatment: "预处理类型:",
    IncludetheMDjustification: "列入mD理由说明:",
    MaterialCategoryName: "材料类别名称:",
    MaterialCategorySubdivision: "材料类别细分项:",
    analysisMode: "分析方式:",
    Analysisrules: "分析规则:",
    Specificmaterial: "特定物质:",
    syncResult: "同步状态:",
    reportName: "报告名称:",
    reportSource: "报告名称:",
    NameBeforeChange: "变更前名称:",
    SupplyNumberBeforeChange: "变更前供货编号:",
    NameAfterChange: "变更后名称:",
    SupplyNumberAfterChange: "变更后供货编号:",
    ID_VersionBeforeChange: "变更前ID/版本:",
    ID_VersionAfterChange: "变更后ID/版本:",
    RemarksBeforeChange: "变更前备注:",
    RemarksAfterChange: "变更后备注:",
    ExtendedComponentName: "扩展零部件名称:",
    CombinedSymbols: "符号组合:",
    Combinedchickboxtitle1: "增塑剂 ISO 1043-3或GB/T1844.3(可选项):",
    Combinedchickboxtitle2: "阻燃剂 ISO 1043-4或GB/T1844.4(可选项):",
    Combinedchickboxtitle3: "热塑性弹性体 ISO 18064或GB/T 22027:",
    ToDeclare: "需申报",
    BeBanned: "被禁止",
    SVHC: "高关注",
    TSS: "任务状态:",
    Details: "数据表详情",
    Status: "状态:",
    DUNSCode: "DUNS编号:",
    address: "地址:",
    Country: "国家/地区:",
    MDSCreater: "MDS创建人",
    Phone: "电话号码:",
    Telefax: "传真号码:",
    Contact: "MDS联系人",
    PageUp: "上一页",
    PageDown: "下一页",

    Expired_domestic: "是否过期(国际):",
    Expired_abroad: "是否过期(国外):",
    citationAnalysis: "引用分析",
    title: "标题:",
    content: "内容:",
    MatchingData: "匹配数据源:",
    CalculateTheMass: "计算节点质量",
    assembly: "总成",
    table_userName:"用户名",//表格
    table_enterpriseName:"企业名称",
    table_status:"状态",
    table_releaseDate: "发布日期",
    table_scipBomcreateTime: "通报BOM生成时间",
    table_CommonNameofParts: "零部件通用名称",
    table_LabelCheckResult: "标注校验结果",
    table_partName: "零部件名称",
    table_partID: "零部件号",
    table_MissingPosition: "标注缺失位置",
    table_AnnotatedLockedState: "标注锁定状态",
    table_Formtype: "表单类型",
    table_FormTheSource: "表单来源",
    table_FormID: "表单ID",
    table_productName: "产品名称",
    table_SupplierID: "供货编号",
    table_CreateAnEnterprise: "创建企业",
    table_dataState: "数据状态",
    table_auditStatus: "审核状态",
    table_QueryTimeType: "查询时间类型",
    table_IDversions: "ID/版本",
    table_MDSState: "MDS状态",
    table_time: "时间",
    table_audittime: "审核时间",
    table_timeshow: "请设置查询时间类型",
    table_acceptingState: "接收状态",
    table_downloadStatus: "下载状态",
    table_loginName: "CAMDS账号",
    table_IMDSloginName: "IMDS账号",
    table_enterpriseID: "企业ID",
    table_operationTime: "操作时间",
    table_downloadResults: "下载结果",
    table_type: "类型",
    table_level: "级别",
    table_levelName: "节点名称",
    table_node: "节点",
    table_checkContent: "校验内容",
    table_errorInfo: "错误信息",
    table_FirstResponsiblePerson: "一级责任人",
    table_SecondaryResponsiblePerson: "二级责任人",
    table_ThirdPartyResponsiblePerson: "三级责任人",
    table_checkDetail: "校验结果",
    table_analysisResult: "物质分析结果",
    table_assignAuditors: "指定审核员",
    table_actualauditor: "实际审核员",
    table_auditResult: "审核结果",
    table_materialName: "材料名称",
    table_substanceName: "物质名称",
    table_elementName: "元素名称",
    table_lawRate: "法规比例",
    table_actualRatio: "实际比例",
    table_applicationOptions: "应用选项",
    table_qualified: "合格",
    table_rule: "规则",
    table_BOMType: "BOM类型",
    table_vehicle: "车型分类",
    table_brandName: "品牌名称",
    table_modelName: "车型名称",
    table_WhetherOpen: "是否开放",
    table_isDefault: '是否默认',

    // table_updateTime: '更新时间',
    table_lockState: "锁定状态",
    table_BOMState: "BOM状态",
    table_Announcement: "公告批次",
    table_Themass: "整车质量(%)",
    table_Themassg: "整车质量(Kg)",
    table_name: "名称",
    table_Num: "数量",
    table_Weight: "质量(g)",
    table_DesignQuality: "设计质量(g)",
    table_materials: "材料",
    table_department: "部门",
    table_substanceName: "物质名称",
    table_CASNum: "CAS号",
    table_proportionType: "比例类型",
    table_ratio: "比例(%)",
    table_MaxRatio: "最大比例(%)",
    table_MinRatio: "最小比例(%)",
    table_matchingState: "匹配状态",
    table_enterprisePartsName: "企业零部件名称",
    table_PartNumber: "零部件编号",
    // table_supplierName: '供应商名称',
    table_MaterialNumber: "材料数据报表编号/版本",
    table_remarks: "备注",
    table_CheckTheType: "校验类型",
    table_availableOrNot: "是否启用",
    table_lawsName: "法规名称",
    table_lawsType: "法规类型",
    table_updateTime: "更新时间",
    table_enName: "英文名称",
    table_materialClassification: "物质分类",
    table_GADSL: "物质分类",
    table_REACH: "REACH-SVHC高关注物质",
    table_another: "别名",
    table_materialCategories: "材料类别",
    table_MarkPhase: "标注阶段",
    table_MTRTechnology: "mTr已验证技术",
    table_materialsRange: "材料范围",
    table_MaterialIdentification: "材料标识",
    table_fileType: "文件类型",
    table_fileName: "文件名称",
    table_NameOfEnterprise_department: "企业/部门",
    table_SuperiorEnterprises_departments: "上级企业/部门",
    table_CAMDS_ID: "CAMDS系统ID",
    table_industryTitle: "部门名称",
    table_SuperiorOrganization: "上级组织机构",
    table_user_Name: "姓名",
    table_Login_Name: "登录名",
    table_role: "角色",
    table_phone: "联系电话",
    table_email: "电子邮箱",
    table_registeredAddress: "注册地址",
    table_RoleManage: "角色信息",
    table_ModelInformation: "车型信息",
    table_rank: "级别",
    table_use: "用途",
    table_CharacterName: "角色名称",
    table_DataPermission: "数据权限",
    table_MenuPermissions: "菜单权限",
    table_numberOfUsers: "用户数量",
    table_operationType: "操作类型",
    table_operationContent: "操作内容",
    table_FirmName: "企业名称",
    table_FirmID: "企业ID",
    table_CurrentTips: "当前提示",
    table_currentPassword: "当前密码",
    table_PartID_version: "零部件ID/版本",
    table_MaterialID_version: "材料ID/版本",
    table_MaterialQuality: "材料质量(g)",
    table_assemblypartsName: "总成零部件名称",
    table_assemblypartsCode: "总成零部件供货编号",
    table_assemblypartsID_V: "总成零部件ID/版本",
    table_pathSubsidiary: "路径明细",
    table_GADSLproperties: "GADSL属性",
    table_MaterialMass: "物质质量(g)",
    table_lawRate_rota: "法规比例(%)",
    table_actualRatio_rota: "实际比例(%)",
    table_exemptionOption: "豁免选项",
    table_Qualifieddetermination: "合格判定",
    table_MarkTime: "标注时间",
    table_RecyclingStage: "回收利用阶段",
    table_PreprocessingStage: "预处理阶段",
    table_MaterialCode: "材料代号标识",
    table_Technology: "已验证技术",
    table_Available: "可再利用率(%)",
    table_Recyclable: "可回收利用率(%)",
    table_Icon: "图标",
    table_Description: "描述",
    table_ProductDescription: "中文描述",
    table_EnglishDescription: "英文描述",
    table_syncStatus: "同步状态",
    table_syncResult: "同步结果",
    table_SynchronizationResults: "同步结果",
    table_SynchronizationResultsTime: "同步结果时间",
    table_reportName: "报告名称",
    table_reportSource: "报告来源",
    table_reportTime: "报告时间",
    table_MessageReception: "消息接收时间",
    table_NameBeforeChange: "变更前名称",
    table_SupplyNumberBeforeChange: "变更前供货编号",
    table_NameAfterChange: "变更后名称",
    table_SupplyNumberAfterChange: "变更后供货编号",
    table_ID_VersionBeforeChange: "变更前ID/版本",
    table_ID_VersionAfterChange: "变更后ID/版本",
    table_RemarksBeforeChange: "变更前备注",
    table_RemarksAfterChange: "变更后备注",
    table_SupplierBeforeChange: "变更前供应商",
    table_SupplierAfterChange: "变更后供应商",
    table_substanceName_Zh: "物质中文名",
    table_substanceName_En: "物质英文名",
    table_ProportionalMaximum: "比例最大值",
    table_title: "标题",
    table_content: "内容",

    table_CAScode: "CAS编号",
    table_ECcode: "EC编号",
    table_GADSLclassify: "GADSL分类",

    table_FirstResponsibleName: "一级责任人姓名",
    table_SecondaryResponsibleName: "二级责任人姓名",
    table_ThirdResponsibleName: "三级责任人姓名",
    table_TSS: "任务状态",
    table_title_one: "字段一",
    table_title_two: "字段二",
    table_title_three: "字段三",
    table_EN: "英文",
    table_CH: "中文",
    Custom_fields_one: "自定义字段一",
    Custom_fields_two: "自定义字段二",
    Custom_fields_three: "自定义字段三",
    EN: "英文:",
    CH: "中文:",
    table_supplierTel: "供应商电话",
    table_supplierEmail: "供应商邮箱",
    table_SQE: "供应商质量检测人员",
    table_Expired_domestic: "是否过期(国内)",
    table_Expired_abroad: "是否过期(国外)",
    table_uploadDate: "上传日期",
    table_ChineseName: "中文名称",
    table_supplierName: "供应商名称",
    // table_supplierEmail:'供应商邮箱',
    // table_supplierTel:'供应商电话',
    supplierRanking: "供应商排名",
    ranking: "排名",
    score: "得分",
    allScore: "总分",
    toBeCalculated: "待计算",
    customerRating: "客户打分",
    trainingPoints: "培训分",
    loginScore: "登录分",
    approvalRate: "批准率",
    dataFillScore: "数据填报分",
    regulationCompliance :"法规符合",
    onceAprovalScore: "一次批准分",
    subjectiveEvaluation: "客户主观评价",
    crths: "有害物质合规应对",
    plcr: "聚合物合规应对",
    dataStandardization: "数据规范",
    systemJudgment: "系统判定",
    carModel: "车型",
    batchAdd: "批量新增",
    alldelete: "批量删除",
    allchick: "批量审核",
    allinvalid: "批量无效",
    BatchSynchronization: "批量同步状态",
    export: "数据导出",
    DownloadTheTemplate: "下载模板",
    look: "查看",
    viewDetailed: "查看详情",
    lookmodel: "查看车型",
    svhcAnalysis: "SVHC分析",
    scipNotification: "SCIP通报",
    exportReport: "导出分析结果",
    createNotificationBOM: "生成通报BOM",
    SVHCAnalysisResult: "SVHC分析结果",
    chick: "审核",
    delete: "删除",
    hide: "隐藏",
    normal:"正常",
    more: "更多",
    resetPassword: "密码重置",
    checkAgain: "重新校验",
    auditLogging: "查看审核记录",
    checkDetail: "校验结果明细",
    analysisResult: "物质分析结果明细",
    materialAnalysis: "物质分析",
    Invalid: "无效设置",
    BatchUpload: "批量上传",
    dataImport: "数据导入",
    location: "定位",
    back: "返回",
    AnalysisOfTheRules: "分析规则",
    BatchPasswordReset: "批量密码重置",
    add: "新增",
    edit: "编辑",
    reject: "拒绝",
    ratify: "批准",
    Fratify: "强制通过",
    newModels: "新增车型",
    copy: "复制",
    lock: "锁定",
    unlock: "解锁",
    link: "挂接",
    open: "打开",
    close: "关闭",
    changeInformation: "修改信息",
    changePassword: "修改密码",
    causeOfInvalidity: "无效原因:",
    causeClassification: "可选拒绝原因:",
    refuseReason: "拒绝原因:",
    isvalid: "有效",
    isinvalid: "无效",
    isdelete: "确认是否删除?",
    isdelete2: "确认删除本条记录?",
    message: "提示",
    confirm: "确定",
    cancel: "取消",
    operation: "操作",
    batchDownload: "批量下载",
    downloadHistory: "下载记录",
    logInAndQuery: "登录并查询",
    logInHistory: "历史记录",
    fillingIn: "填入",
    search: "查询",
    nextSearch: "下一查询",
    reset: "重置",
    language: "语言",
    SwitchAccountQuery: "切换账号查询",
    downloadViewDetailed: "下载记录--查看详情",
    errorInfo: "错误信息",
    loginNameChange: "CAMDS账号切换",
    uploadTask: "上传分发任务",
    examine: "查看明细",
    modifyTheTask: "编辑分发",
    download: "下载",
    downloadSupply: "重新下载",
    lockBOM: "锁定BOM",
    unlockBOM: "解锁BOM",
    MaterialDetailed: "物质明细",
    write: "填报",
    Cancel: "取消填报",
    BOMTree: "BOM树结构",
    exportBOM: "导出BOM",
    match: "整体匹配",
    NodeInformation: "节点信息",
    TheMaterialInformation: "物质信息",
    MatchingResults: "匹配结果",
    TheResultsDerived: "导出结果",
    matching: "匹配",
    matchedNodes: "只匹配未成功匹配节点",
    MatchAllNodes: "匹配全部节点",
    Fillintheinformation: "填报信息",
    ModifyAuditRules: "编辑审核规则",
    laws: "法规",
    MaterialRangeDetermination: "材料范围判定",
    synchronizationInformation: "同步信息",
    basicInformation: "基本信息",
    upload: "点击上传",
    Upload: "上传",
    RRRannotation: "RRR标注",
    BatchAutomaticLabeling: "批量自动标注",
    BatchLabelVerification: "批量标注校验",
    label: "标注",
    Unlabel: "取消标注",
    detail: "明细",
    apply: "应用",
    CheckCar: "查看车型",
    Immunity: "豁免标注",
    material_Analysis: "材料分析",
    VehicleAnalysis: "整车分析",
    ComponentAnalysis: "零部件分析",
    VehicleAnalysis_item1: "材料分类",
    VehicleAnalysis_item2: "整车材料明细",
    VehicleAnalysis_item3: "整车偏差分析",
    VehicleAnalysis_item4: "零部件材料明细",
    VehicleAnalysis_item5: "零部件偏差分析",
    sample: "样本",
    Yes: "是",
    No: "否",
    polyphyletic: "多源的:",
    preferred: "首选的:",
    doubtful: "未确定",
    LocalMatching: "局部匹配",
    searchTree: "查找树",
    next: "下一个",
    HarmfulAnnotation: "有害标注",
    RemovalofHarmfulLabel: "取消有害标注",
    Recycling: "回收利用率信息标注",
    unRecycling: "取消回收利用率信息标注",
    Choosematerial: "选择物质",
    analyse: "分析",
    exportList: "导出有害物质清单",
    HarmfulInformation: "有害标注信息",
    LabelingInformation: "标注信息",
    RecyclingRate: "回收利用率计算",
    calculation: "两率计算",
    exportCalculate: "两率导出",
    exportCalculate_EU: "两率导出(欧盟)",
    unlocked: "取消锁定",
    MarkCheck: "标注校验",
    Clearlabel: "清空标注",
    clear:"清空",
    Automatic: "自动标注",
    Parameters: "参数报告",
    searchParameters: "请输入查找参数",
    exportMaterialAnalysis: "物质分析结果导出",
    banner: "公告栏",
    AgentManagement: "待办管理",
    FileManagement: "文件管理",
    ReportDownload: "报告下载",
    change: "变更",
    Extend: "扩展",
    ExportRecordTable: "导出备案表",
    choose: "选择",
    PartsChangeList: "零部件变更列表",
    PartsExtendedList: "零部件扩展列表",
    ExportingExtendedTable: "导出扩展表",
    prohibitedSubstances: "禁限用物质应用标准",
    Modify: "编辑",
    standardWindow: "查询标识引用标准窗口",
    ChangeMaterialIdentification: "更改材料标识",
    applicationCriterions: "禁用物质应用标准",
    materiallCodeTitle:
      "所选物质分类允许通过下拉菜单并按照CAMDS的基本聚合物清单创建物质名称和响应符号请选择适合此物质的符号/缩略语",
    materiallCodeFotter:
      "您也可以单独编辑此符号标记,此项对于带有多个填充剂的物质(例如 玻璃纤维GF 和矿物粉 MD)是必要的。例如PA6-(GF15+MD10);此处您可以单独添加",
    BasePolymer: "基础聚合物",
    Fillers_reinforcingMaterials: "填充剂/加强材料",
    or: "或",
    SearchForParts: "零部件种类查找",
    check: "校验",
    internalRelease: "内部发布",
    addparts: "零件",
    addSemi_finished: "半成品",
    addMaterial: "材料",
    addmatter: "物质",
    addmodule: "组件",
    DeletesNode: "删除当前节点",
    DeletesNodeAndChildren: "删除当前节点及子节点",
    Displace: "置换",
    AddNewNode: "本地数据新增节点",
    AddNewMaterial: "新增物质",
    ConversionComponents: "转化组件",

    // CQC相关
    CQCfill: "CQC填报",
    ProjectName: "项目名称:",
    project:'项目',
    PowerPlantID: "动力装置:",
    applicationID: "CCC申请编号:",
    CurbWeight: "整备质量:",
    Reusability: "可再利用率:",
    RecoveryRate: "可回收利用率:",
    VehicleInternalNumber: "车辆内部编号:",
    table_ProjectName: "项目名称",
    table_PowerPlantID: "动力装置ID",
    table_VehicleType: "车辆型号",
    table_Creater: "创建人",
    table_CreationTime: "创建时间",
    Plug_inhybrid: "插电式混合动力",
    Pureelectric: "纯电动",
    hybrid: "混合动力",
    AFuelCell: "燃料电池",
    ICE: "内燃机",
    cqc_weight: "质量:",
    Generate: "生成报告",
    uplodaGenerate: "上传报告",
    Failed: "未匹配成功",
    Editmodels: "编辑车型",
    version: "表单版本:",
    VendorID: "供应商ID:",
    noConformToData: "没有符合条件的数据！",
    upLoadTips1: "只能上传xls、xlsx、csv文件，且不超过100M",
    mustRequestOpen: "请选择是否公开",
  },
  EN: {
    //英文翻译
    colon: ":",
    select: "Please choose ...",
    create: "Create",
    find: "Search",
    save: "Save",
    warn: "Warn",
    continue: "Continue",
    submit: "submit",
    confirmCommit: "Confirm submission",
    confirmSend: "Confirm sending",
    confirmReply: "Confirm reply",
    confirmed: "Confirmed",
    confirm: "Confirm",
    view: "View",
    pleaseSelect: "Please select data",
    noDataUpdate: "No data update",
    noFileDownload: "No file download",
    inputModify: "Modify",
    noData: "No Data",
    setSuccessfully: "Set Success",
    unset: "unset",
    export: "Export",
    templateDownload: "Template Download",
    textDescription: "Description",
    file: "file",
    contactInformation: "Contact Information",
    // reset: "Reset",
    // add: "Add",
    status0: "Not analyzed",
    status1: "success",
    status2: "failure",
    status3: "processing",
    status4: "Completed",
    operate: "Operate",
    newAdd: "New",
    modify: "Modify",
    // delete: "Delete",
    pleaseInput: "Please input ",
    positiveInteger: "Positive integer",
    yes: "Yes",
    no: "No",
    tips: "Tips",
    success: "success",
    sendSuccess: "Successfully sent",
    rowSelect: "Please select data",
    received: "received",
    // isdelete: "Are you sure to delete the record?",
    // confirm: "confirm",
    // cancel: "cancel",
    mdsUpdateResults: "Update Results",
    compare:"Compare",
         startCompare:"Start comparison",
    joined:"Joined",
    metalPPM: "metalPPM(<=):",
    nonMetallicPPM: "non-metallicPPM(<=):",
    sort: "sort:",
    classification: "Classification",
    CustomSettings: "Custom Settings",
    subInformationFill: "fill substance information",
    workSpaceInformationFill: "Working context",
    validate: "Validate",
    checkDossier: "Check dossier",
    createDossier: "Create dossier",
    exportDossier: "Export dossier",
    submitECHA: "Submit ECHA",
    revalidate: "Re-validate",
    editDossier: "Edit draft dossier header",
    exportExcel: "Export to Excel",
    // 按钮，标题，输入框
    logout: "Log Out",
    systemFolder: "System File",
    ModelFile: "Model File",
    logoTit: "SCIP System",
    reviewTheRules: "Review Rules",
    reviewInformation: "Review Info",
    regulatoryInformation: "Regulatory Information",
    taggingRulesList: "Tagging Rules",
    taggingRulesInfo: "Material Scope Determination Management",
    camds_system: "CAMDS",
    imds_system: "IMDS",
    Localsystem: "Local",
    searchCriteria: "Search Criteria",
    LocalData: "Local Data Management",
    departmentInfo: "DepartmentInfo",
    BasicDataSynchronization: "Basic Data Download",
    MDSDataSynchronization: "MDS Data  Download",
    DataSynchronization: "Data Download",
    auditDistribute: "Task Distribution",
    userManage: "User Info",
    pageViews: "Page Views",
    personalManage: {
      organization: "Organization Info",
      car: "Vehicle Info",
    },
    // RoleManage: 'Role Info',
    LogManage: "Log Info",
    ConfigurationManage: {
      data: "Data Download Account Configuration",
      add: "Add account password configuration",
      help: "Help Prompt Content Configuration",
      banner: "Report information configuration",
      BOM: "BOM configuration information field",
      Datastate:
        "Download the CAMDS local creation form automatically approved",
    },
    // ModelInformation: 'Model Info',
    ModelBOMList: "BOM Info",
    startTime: "Start Time:",
    endTime: "End Time:",
    operationTime: "Choose Time:",
    enterpriseInformation: "Enterprise Info",
    primarySubstance: "Primary Substance",
    standardMaterial: "Standard Material",
    materialsClassification: "Materials Classification",
    ApplicationOfOption: "Application Of Option",
    PolymerLabel: "Polymer Label",
    quotedStandard: "Quoted Standard",
    serialNumber: "No.",
    operator: "Operator",
    chickoperationTime: "Operation Time:",
    Synchronization: "Synchronization",
    parameter: "Parameter",
    result: "Result",
    explain: "Explain",
    SynchronizationSuccse: "Success!",
    down: "DOWN",
    up: "UP",
    Formtype: "MDS Type:",
    FormTheSource: "MDS Source:",
    FormID: "MDS ID:",
    productName: "Product Name:",
    SupplierID: "Supplier ID:",
    cstandardSymbol: "Standard material No:",
    CreateAnEnterprise: "Supplier Name:",
    dataState: "Data State:",
    auditStatus: "Audit Status:",
    QueryTimeType: "Query Time Type:",
    IDversions: "ID/Versions:",
    MDSState: "MDS State:",
    acceptingState: "Accepting State:",
    downloadStatus: "Download Status:",
    downloadResults: "Download Results:",
    CAMDSloginName: "CAMDS LoginName:",
    IMDSloginName: "IMDS LoginName:",
    CAMDSpassword: "CAMDS Password:",
    FirstResponsiblePerson: "First responsible:",
    SecondaryResponsiblePerson: "Second responsible:",
    ThirdPartyResponsiblePerson: "Third responsible:",
    enterpriseID: "Enterprise ID:",
    brandName: "Brand Name:",
    modelName: "Model Name:",
    BOMType: "BOM Type:",
    BannerType: "Banner Type:",
    vehicle: "Vehicle Type:",
    commonName: "Common Name:",
    ModelType: "Model Type:",
    type: "Type:",
    style: "Style:",
    Themass: "The Mass(g):",
    quality: "Quality(g):",
    Quality: "Quality:",
    manufacturingEnterprise: "Enterprise:",
    dateCreated: "Date Created:",
    bannerDate: "Bulletin Time:",
    optionDate: "Option Date:",
    Announcement: "Announcement of the batch:",
    name: "Name:",
    CheckTheType: "Check Type:",
    availableOrNot: "Available Or Not:",
    lawsName: "Laws Name:",
    lawsType: "Laws Type:",
    updateTime: "Update Time:",
    matterName: "Matter Name:",
    materialName_en: "MaterialName(EN):",
    enName: "English name:",
    CASNum: "CAS Code:",
    materialClassification: "Material Classification:",
    ratio: "Ratio:",
    materialCategories: "Material Categories:",
    mixCategories: "Mixture Categories:",
    MarkPhase: "Mark Phase:",
    MTRTechnology: "MTR Technology:",
    materialsRange: "Materials Range:",
    MaterialIdentification: "Material Identification:",
    materialName: "Material Name:",
    fileType: "File Type:",
    fileName: "File Name:",
    remarks: "Remarks:",
    NameOfEnterprise_department: "Name of enterprise/department:",
    CAMDS_ID: "CAMDS ID:",
    industryTitle: "Industry Title:",
    SuperiorOrganization: "Superior Organization:",
    user_Name: "Name:",
    Login_Name: "Login Name:",
    role: "role:",
    phone: "Phone:",
    email: "Email:",
    RoleManage: " Role Info:",
    ModelInformation: "Model Info:",
    oldPassword: "Old Password:",
    newPassword: "New Password:",
    reconfirm: "Reconfirm:",
    CharacterName: "Character Name:",
    DataPermission: "Data Permission:",
    MenuPermissions: "Menu permissions:",
    operationType: "Operation Type:",
    FirmName: "Enterprise Name:",
    FirmID: "Firm ID:",
    TheNewTips: "The New Tips:",
    CurrentTips: "Current Tips:",
    SynchronousTime: "Synchronous Time:",
    SynchronousStateTime: "Synchronous State Time:",
    OpenSynchronization: "Open Synchronization:",
    password: "Password:",
    UserID: "User ID:",
    AccessAddress: "Access Address:",
    KEY: "Key:",
    UserName: "User Name:",
    FilterType: "Filter Type:",
    mpType: "mp Type:",
    AnnotatedLockedState: "Annotated locked state:",
    NodeNumberCalculation: "Node number calculation:",
    partName: "Part Name:",
    partName_en: "Part Name(EN):",
    partType: "part Type",
    partID: "part ID:",
    SingleMassValueMeasuredByZeroPart:
      "Single mass value measured by zero part:",
    CalculatedSingleMassValue: "Calculated single mass value:",
    ThePolymersHaveBeenLabeled: "The polymers have been labeled:",
    ThePolymersHaveBeenLabeled_item1:
      "Yes (marked according to relevant regulations)",
    ThePolymersHaveBeenLabeled_item2:
      "No (not marked in accordance with relevant regulations)",
    ThePolymersHaveBeenLabeled_item3:
      "Not applicable (no need to mark according to relevant regulations)",
    deviation: "Deviation:",
    surveyDate: "Survey Date:",
    releaseDate: "Release Date:",
    Num: "Quantity:",
    reportName: "Report Name:",
    reportSource: "Report Source:",
    NameBeforeChange: "Name Before Change:",
    SupplyNumberBeforeChange: "Supply Number Before Change:",
    NameAfterChange: "Name After Change:",
    SupplyNumberAfterChange: "Supply Number After Change:",
    ID_VersionBeforeChange: "ID/Version Before Change:",
    ID_VersionAfterChange: "ID/Version After Change:",
    RemarksBeforeChange: "Remarks Before Change:",
    RemarksAfterChange: "Remarks After Change:",
    ExtendedComponentName: "Extended Component Name:",
    CombinedSymbols: "Combined Symbols:",
    Combinedchickboxtitle1: "Plasticizer ISO 1043-3 or GB/T1844.3(optional):",
    Combinedchickboxtitle2:
      "Flame retardants ISO 1043-4 or GB/T1844.4(optional):",
    Combinedchickboxtitle3: "Thermoplastic elastomers ISO 18064 or GB/T 22027:",
    ToDeclare: "To Declare",
    BeBanned: "Be Banned",
    SVHC: "SVHC",
    TSS: "Task Status:",
    Details: "Details",
    Status: "Status:",
    DUNSCode: "DUNS Code:",
    address: "Address:",
    Country: "Country/Region:",
    MDSCreater: "MDS Creater",
    Phone: "Phone:",
    Telefax: "Telefax:",
    Contact: "MSD Contact",
    PageUp: "Page Up",
    PageDown: "Page Down",

    lookmodel: "view model",
    svhcAnalysis: "SVHC analysis",
    SVHCAnalysisResult: "SVHC analysis Result",
    exportReport: "Export Results",
    createNotificationBOM: "create notification BOM",
    MaterialPartNumber: "Material part number:",
    productname: "Product Name:",
    materialsClass: "Materials Classification:",
    MaterialCode_Mark: "Material code/mark:",
    MaterialCode_markingReferenceStandard:
      "Material code/marking reference standard:",
    markingReferenceStandard: "Marking Reference Standard:",
    StandardNo: "Standard no.:",
    MaterialReportNo: "Material Report No.:",
    RecirculatingMaterial: "Recirculating material:",
    Whether: "Whether the material contains recycled material",
    T24021: "See the GB/T24021",
    industrial: "Recycled from industrial waste:",
    waste: "Recycled from waste materials:",
    form: "Form",
    to: "To",
    finishedName: "Name of semi-finished parts:",
    finishedName_en: "Name of semi-finished parts(EN):",
    finishedNum: "Semi-finished part number:",
    average: "Average",
    fixed: "fixed",
    surplus: "surplus",
    NameOfBasicSubstance_zh: "Chinese name of basic substance:",
    NameOfBasicSubstance_en: "English name of basic substance:",
    CAScode: "CAS Code:",
    ECcode: "EC Code:",
    GADSLclassify: "GADSL Classify:",
    another: "another name",
    secrecy: "Secrecy:",
    DesignQuality: "Design Quality(g):",
    materials: "Materials:",
    department: "Department:",
    NameChinese: "Chinese or not:",
    ChineseName: "Chinese Name:",
    CommonNameofParts: "Common Name of Parts:",
    HarmfulLabelingInformation: "Harmful Labeling Info:",
    RecyclingStage: "Recycling Stage:",
    Typeofpretreatment: "MD type:",
    IncludetheMDjustification: "Include the MD justification:",
    MaterialCategoryName: "Material Category Name:",
    MaterialCategorySubdivision: "Detailed Classification Of Materials:",
    analysisMode: "Analysis type:",
    Analysisrules: "Analysis rules:",
    syncResult: "Synch State",
    Specificmaterial: "Specific material",
    batchAdd: "Batch Add",
    alldelete: "Batch delete",
    carModel: "models",
    allchick: "Batch Review",
    allinvalid: "The Batch Is Invalid",
    BatchSynchronization: "Batch Synchronization",
    export: "Data Export",
    DownloadTheTemplate: "Download the template",
    look: "View",
    viewDetailed: "Detailed",
    chick: "Audit",
    delete: "Delete",
    hide: "Hide",
    normal:"Normal",
    more: "More",
    resetPassword: "Reset Password",
    checkAgain: "Check Again",
    auditLogging: "Check Logging",
    checkDetail: "Check Detail",
    analysisResult: "Analysis Result",
    materialAnalysis: "Material Analysis",
    Invalid: "Invalid Set",
    BatchUpload: "Batch Upload",
    dataImport: "Data Import",
    location: "Location",
    back: "Go Back",
    AnalysisOfTheRules: "Analysis Rules",
    BatchPasswordReset: "Batch password reset",
    add: "Add",
    edit: "Edit",
    reject: "Reject",
    ratify: "Force through",
    Fratify: "",
    newModels: "Add",
    copy: "Copy",
    lock: "lock",
    unlock: "unlock",
    link: "Link",
    open: "Open",
    close: "Close",
    changeInformation: "Change Info",
    changePassword: "Change Password",
    causeOfInvalidity: "Cause invalidity:",
    causeClassification: "Selection of causes:",
    refuseReason: "Reason:",
    isvalid: "Valid",
    isinvalid: "Invalid",
    isdelete: "Confirm Whether To Delete?",
    message: "Message",
    confirm: "Confirm",
    cancel: "Cancel",
    operation: "Operation",
    batchDownload: "Batch Download",
    downloadHistory: "Download History",
    logInAndQuery: "Login And Query",
    logInHistory: "Login History",
    fillingIn: "Filling-in",
    search: "Search",
    nextSearch: "Next search",
    reset: "Reset",
    language: "Language",
    SwitchAccountQuery: "Change",
    downloadViewDetailed: "Download History--View Detailed",
    errorInfo: "Error Message",
    loginNameChange: "CAMDS Account",
    uploadTask: "Batch Upload",
    examine: "examine",
    modifyTheTask: "Modify the task",
    download: "Download",
    lockBOM: "Lock the BOM",
    unlockBOM: "Unlock the BOM",
    MaterialDetailed: "Detailed",
    write: "Fill",
    Cancel: "Cancel",
    BOMTree: "BOM Structure",
    exportBOM: "Export BOM",
    match: "The Whole Match",
    NodeInformation: "Node Info",
    TheMaterialInformation: "Substance Info",
    MatchingResults: "Matching Results",
    TheResultsDerived: "Export Results",
    matching: "Matching",
    matchedNodes: "Matches only unsuccessfully matched nodes",
    MatchAllNodes: "Match all nodes",
    Fillintheinformation: "Fill In The Information",
    ModifyAuditRules: "Modify Audit Rules",
    laws: "laws",
    MaterialRangeDetermination: "Material Range Determination",
    synchronizationInformation: "Synchronization Info",
    basicInformation: "Basic Info",
    upload: "Upload File",
    Upload: "Upload",
    RRRannotation: "RRR Annotation",
    BatchAutomaticLabeling: "Batch labeling",
    BatchLabelVerification: "Batch verification",
    label: "Label",
    Unlabel: "Cancel Labeling",
    detail: "Detail",
    apply: "Apply",
    CheckCar: "View",
    Immunity: "Immunity Labeling",
    material_Analysis: "Material Analysis",
    VehicleAnalysis: "The vehicle analysis",
    ComponentAnalysis: "Component Analysis",
    VehicleAnalysis_item1: "Materials classification",
    VehicleAnalysis_item2: "Material details",
    VehicleAnalysis_item3: "Deviation analysis",
    VehicleAnalysis_item4: "Material details of spare parts",
    VehicleAnalysis_item5: "Component deviation analysis",
    sample: "Sample",
    Yes: "Yes",
    No: "No",
    polyphyletic: "Polyphyletic:",
    preferred: "Preferred:",
    doubtful: "doubtful",
    LocalMatching: "Local matching",
    searchTree: "Search",
    next: "Next",
    HarmfulAnnotation: "Harmful Annotation",
    RemovalofHarmfulLabel: "Removal of Harmful Label",
    Recycling: "Recycling rate information labeling",
    unRecycling: "Cancel labeling",
    Choosematerial: "Choose Subs",
    analyse: "Analyse",
    exportList: "Export List",
    HarmfulInformation: "Harmful Labeling Info",
    LabelingInformation: "Labeling Info",
    RecyclingRate: "Recycling Rate Calculation",
    exportCalculate: "Two Rate Export",
    exportCalculate_EU: "Two Rate Export(EU)",
    calculation: "Two rate calculation",
    unlocked: "unlocked",
    MarkCheck: "Mark check",
    Clearlabel: "Clear label",
    clear:"Clear",
    Automatic: "Automatic tagging",
    Parameters: "Report Parameters",
    searchParameters: "Please enter search parameters",
    exportMaterialAnalysis: "Export List",
    banner: "Billboard",
    title: "Title:",
    content: "Content:",

    MatchingData: "MatchingData:",
    CalculateTheMass: "Quality of compute nodes",
    assembly: "assembly",
    
    AgentManagement: "Agent Management",
    FileManagement: "File Management",
    ReportDownload: "Report Download",
    change: "Change",
    Extend: "Extend",
    ExportRecordTable: "Export Record Table",
    choose: "Choose",
    PartsChangeList: "Parts Change List",
    PartsExtendedList: "Parts Extended List",
    ExportingExtendedTable: "Exporting Extended Table",
    prohibitedSubstances: "Standard for application of prohibited substances",
    Modify: "Modify",
    standardWindow: "Query ID references the standard window",
    ChangeMaterialIdentification: "Change material identification",
    applicationCriterions: "application Criterions",
    materiallCodeTitle:
      "The classification of selected substances allows you to create a substance name and response symbol from the drop-down menu and from the basic polymer list of CAMDS. Please select a symbol/acronym that is appropriate for this substance",
    materiallCodeFotter:
      "You can also modify this symbol separately, which is necessary for substances with multiple fillers, such as fiberglass GF and mineral powder MD. Such as PA6 - (GF15 + MD10); Here you can add it separately",
    BasePolymer: "Base polymer",
    Fillers_reinforcingMaterials: "Fillers/Reinforcing Materials",
    or: "or",
    SearchForParts: "Search for parts and components",
    check: "Check",
    internalRelease: "Internal Release",
    addparts: "Parts",
    addSemi_finished: "Semi-finished",
    addMaterial: "Material",
    addmatter: "Related substance",
    addmodule: "Module",
    DeletesNode: "Deletes node",
    DeletesNodeAndChildren: "Deletes node and children",
    Displace: "Displace",
    AddNewNode: "Add New Node",
    AddNewMaterial: "Add New Material",
    ConversionComponents: "Conversion Components",
    Expired_domestic: "Expired (domestic):",
    Expired_abroad: "Expired (abroad):",
    citationAnalysis: "Citation Analysis",
    statisticalChart: "Statistical Chart",
    // 表格
    table_CommonNameofParts: "Common Name of Parts",
    table_LabelCheckResult: "Label result",
    table_partName: "Part Name",
    table_partID: "Part number",
    table_MissingPosition: "Missing position",
    table_AnnotatedLockedState: "Locked state",
    table_Formtype: "MDS Type",
    table_FormTheSource: "MDS Source",
    table_FormID: "MDS ID",
    table_productName: "Product Name",
    table_SupplierID: "SupplierID",
    table_CreateAnEnterprise: "Enterprise",
    table_dataState: "Data State",
    table_auditStatus: "Audit Status",
    table_QueryTimeType: "Query Time Type",
    table_IDversions: "ID/Versions",
    table_MDSState: "MDS State",
    table_time: "Time",
    table_audittime: "Audit Time",
    table_timeshow: "Please Set The Query Time Type",
    table_acceptingState: "Accepting State",
    table_downloadStatus: "Download Status",
    table_loginName: "CAMDS Login Name",
    table_IMDSloginName: "IMDS Login Name",
    table_enterpriseID: "Enterprise ID",
    table_operationTime: "ChooseTime",
    table_downloadResults: "Download Results",
    table_type: "Type",
    table_fileName: "File Name",
    table_level: "Level",
    table_levelName: "Level Name",
    table_node: "Node Name",
    table_checkContent: "Check Content",
    table_errorInfo: "Error Message",
    table_FirstResponsiblePerson: "First responsible person",
    table_SecondaryResponsiblePerson: "Secondary responsible person",
    table_ThirdPartyResponsiblePerson: "Third responsible person",
    table_checkDetail: "Check Detail",
    table_analysisResult: "Analysis Result",
    table_assignAuditors: "Assign Auditors",
    table_actualauditor: "Actual Auditor",
    table_auditResult: "Audit Result",
    table_materialName: "Material name",
    table_substanceName: "Substance Name",
    table_elementName: "Element Name",
    table_lawRate: "Law Rate",
    table_actualRatio: "Actual Ratio",
    table_applicationOptions: "Application Options",
    table_qualified: "Qualified",
    table_rule: "Rule",
    table_BOMType: "BOM Type",
    table_vehicle: "Vehicle",
    table_brandName: "Brand Name",
    table_modelName: "Model Name",
    table_WhetherOpen: "Whether open",
    table_updateTime: "Update Time",
    table_lockState: "Lockout State ",
    table_BOMState: "BOM State",
    table_Announcement: "Announcement",
    table_Themass: "The Mass(%)",
    table_Themassg: "The Mass(g)",
    table_name: "Name",
    table_Num: "Quantity",
    table_Weight: "Quality(g)",
    table_DesignQuality: "Design Quality(g)",
    table_materials: "Materials",
    table_department: "Department",
    table_materialName: "Material Name",
    table_CASNum: "CAS Code",
    table_proportionType: "Ratio Type",
    table_ratio: "Ratio(%)",
    table_MaxRatio: "Max Ratio(%)",
    table_MinRatio: "Min Ratio(%)",
    table_matchingState: "Matching State",
    table_enterprisePartsName: "Parts Name",
    table_PartNumber: "Part Number",
    // table_supplierName: 'Supplier Name',
    table_MaterialNumber: "Number/Ver",
    table_remarks: "Remarks",
    table_CheckTheType: "Check Type",
    table_availableOrNot: "Available Or Not",
    table_lawsName: "Laws Name",
    table_lawsType: "Laws Type",
    // table_updateTime: 'Update Time',
    table_enName: "English Name",
    table_materialClassification: "Material Classification",
    table_GADSL: "GADSL",
    table_REACH: "REACH",
    table_another: "Another Name",
    table_materialCategories: "Material Categories",
    table_MarkPhase: "Mark Phase",
    table_MTRTechnology: "MTR Technology",
    table_materialsRange: "Materials Range",
    table_MaterialIdentification: "Material Identification",
    table_fileType: "File Type",
    table_NameOfEnterprise_department: "Name of enterprise/department",
    table_SuperiorEnterprises_departments: "Superior enterprises/departments",
    table_CAMDS_ID: "CAMDS ID",
    table_industryTitle: "Deparment Name",
    table_SuperiorOrganization: "Superior Name",
    table_user_Name: "Name",
    table_Login_Name: "Login Name",
    table_role: "role",
    table_phone: "Phone",
    table_email: "Email",
    table_registeredAddress: "Registered address",
    table_RoleManage: "Role Info",
    table_ModelInformation: "Model Info",
    table_rank: "Rank",
    table_use: "Use",
    table_CharacterName: "Character Name",
    table_DataPermission: "Data Permission",
    table_MenuPermissions: "Menu permissions",
    table_numberOfUsers: "Number Of Users",
    table_operationType: "Operation Type",
    table_operationContent: "Operation Content",
    table_FirmName: "Enterprise Name",
    table_FirmID: "Enterprise ID",
    table_CurrentTips: "Current Tips",
    table_currentPassword: "Current Password",
    table_PartID_version: "PartID/version",
    table_MaterialID_version: "MaterialID/version",
    table_MaterialQuality: "Material Quality(g)",
    table_assemblypartsName: "Assembly Parts Name",
    table_assemblypartsCode: "Assembly Parts Code",
    table_assemblypartsID_V: "Assembly Parts ID/Version",
    table_pathSubsidiary: "Path Subsidiary",
    table_GADSLproperties: "GADSL Properties",
    table_MaterialMass: "Material mass (g)",
    table_lawRate_rota: "Law Rate(%)",
    table_actualRatio_rota: "Actual Ratio(%)",
    table_exemptionOption: "Exemption Option",
    table_Qualifieddetermination: "Qualified Determination",
    table_MarkTime: "Mark Time",
    table_RecyclingStage: "Recycling Stage",
    table_PreprocessingStage: "Preprocessing Stage",
    table_MaterialCode: "Material code",
    table_Technology: "Proven Technology",
    table_Available: "Available Utilization (%)",
    table_Recyclable: "Recyclable Utilization Rate (%)",
    table_Icon: "Icon",
    table_Description: "Description",
    table_ProductDescription: "Product Description",
    table_EnglishDescription: "English Description",
    table_syncResult: "Synch State",
    table_SynchronizationResults: "Results",
    table_SynchronizationResultsTime: "Result Time",
    table_reportName: "Report Name",
    table_reportSource: "Report Source",
    table_reportTime: "Report Time",
    table_MessageReception: "Message Reception Time",
    table_NameBeforeChange: "Name Before Change",
    table_SupplyNumberBeforeChange: "Supply Number Before Change",
    table_NameAfterChange: "Name After Change",
    table_SupplyNumberAfterChange: "Supply Number After Change",
    table_ID_VersionBeforeChange: "ID/Version Before Change",
    table_ID_VersionAfterChange: "ID/Version After Change",
    table_RemarksBeforeChange: "Remarks Before Change",
    table_RemarksAfterChange: "Remarks After Change",
    table_SupplierBeforeChange: "Supplier Before Change",
    table_SupplierAfterChange: "Supplier After Change",
    table_substanceName_Zh: "Material Name(Zh)",
    table_substanceName_En: "Material Name(En)",
    table_ProportionalMaximum: "Proportional Max",
    table_CAScode: "CAS Code",
    table_ECcode: "EC Code",
    table_GADSLclassify: "GADSL Classify",
    table_FirstResponsibleName: "First Responsible Name",
    table_SecondaryResponsibleName: "Secondary Responsible Name",
    table_ThirdResponsibleName: "Third Responsible Name",
    table_TSS: "Task Status",
    table_title: "Title",
    table_content: "Content",
    table_scipBomcreateTime: "SCIP Bom Create Time",
    table_userName:"User Name",
    table_enterpriseName:"Enterprise Name",
    table_status:"Status",
    table_releaseDate: "Release Date",
    table_title_one: "Field one",
    table_title_two: "Field two",
    table_title_three: "Field three",
    table_EN: "English",
    table_CH: "Chinese",
    Custom_fields_one: "Custom fields one",
    Custom_fields_two: "Custom fields two",
    Custom_fields_three: "Custom fields three",
    EN: "English:",
    CH: "Chinese:",
    table_supplierTel: "Supplier Telephone",
    table_supplierEmail: "Supplier E-mail",
    table_SQE: "Testing Personnel",
    table_Expired_domestic: "Expired (domestic)",
    table_Expired_abroad: "Expired (abroad)",
    table_uploadDate: "Upload Date",
    table_ChineseName: "Chinese Name",
    table_supplierName: "Supplier Name",
    // table_supplierEmail:'Supplier Email',
    // table_supplierTel:'Supplier Tel',
    supplierRanking: "Supplier Ranking",
    ranking: 'Ranking',
    score: 'Score',
    allScore: "All Score",
    toBeCalculated: "To be calculated",
    customerRating: "Customer Rating",
    trainingPoints: "Training points",
    loginScore: "Login Score",
    approvalRate: "Approval Rate",
    dataFillScore: "Data Fill Score",
    regulationCompliance: "Regulation Compliance",
    onceAprovalScore:"One-time approval score",
    subjectiveEvaluation: "Customer subjective evaluation",
    crths: "Compliance response to hazardous substances",
    plcr: "Polymer labeling compliance response",
    dataStandardization: "Data standardization",
    systemJudgment: "System Judgment",
    // CQC相关
    CQCfill: "CQCfill",
    ProjectName: "Project Name:",
    project: "Project",
    PowerPlantID: "Power Plant ID:",
    applicationID: "CCC Application ID:",
    CurbWeight: "Curb Weight:",
    Reusability: "Reusability:",
    RecoveryRate: "recoverability rate:",
    VehicleInternalNumber: "Vehicle Internal Number:",
    table_ProjectName: "Project Name",
    table_PowerPlantID: "Power Plant ID",
    table_VehicleType: "Vehicle Type",
    table_Creater: "created By",
    table_CreationTime: "CreationTime",
    version: "version:",
    VendorID: "Vendor ID:",
    noConformToData: "No suitable data!",
    upLoadTips1:
      "Can only upload xls, xlsx, csv files, and does not exceed 100MB",
    Plug_inhybrid: "Plug-in hybrid",
    Pureelectric: "Pure electric",
    hybrid: "hybrid",
    AFuelCell: "A fuel cell",
    ICE: "ICE",
    cqc_weight: "weight:",
    Editmodels: "Redact Models",
    Generate: "Generate a report",
    uplodaGenerate: "Upload the report",
    Failed: "Failed to match",
    mustRequestOpen: "Please choose whether to make it public or not",
  },
};
export default info //需要暴露出去
